import {
  HEADER_EVENTS,
  HEADER_GROUP_OVERVIEW,
  HEADER_INVESTORS,
  HEADER_MAP,
  HEADER_MARKETING,
  HEADER_MEDIA,
} from './headerPaths';

export const WORLD_BASE = '/world';

export const WORLD_MAP = WORLD_BASE + HEADER_MAP;
export const WORLD_GROUP_OVERVIEW = WORLD_BASE + HEADER_GROUP_OVERVIEW;
export const WORLD_INVESTORS = WORLD_BASE + HEADER_INVESTORS;
export const WORLD_MARKETING = WORLD_BASE + HEADER_MARKETING;
export const WORLD_EVENTS = WORLD_BASE + HEADER_EVENTS;
export const WORLD_MEDIA = WORLD_BASE + HEADER_MEDIA;

// Events
export const WORLD_DATA_EVENTS_COUNTRY = `${WORLD_EVENTS}/:country`;
